import {defineMessages} from 'react-intl'

export default defineMessages({
    alterHeader: {
        id: 'components.ErrorBoundary.alert.header',
        defaultMessage: 'Oh no, something bad happened..',
    },
    call_to_action: {
        id: 'components.ErrorBoundary.call.to.action',
        defaultMessage: 'Oh no, something bad happened..',
    },
    errorMessage:{
        id:'components.ErrorBoundary.errorMessage',
        defaultMessage: `
              <h1>Oh no, something bad happened..</h1>
              <p>
                We are terribly sorry, but our browse section on our website are
                having some issue. We are working on it, and it will be
                available again very soon
              </p>

              <p>
                Please reach out to us at  <email_link>{email}</email_link> 
                or call us at <phone_link>{phone_number}</phone_link>, and
                we will assist you right away.
              </p>

              <p>
                You can go back and explore VoiceArchive offerings, explore
                cases and read more about our rates, by following this <link_home_page> link </link_home_page>.
              </p>
              <p>
                <span>&#10230;</span><link_home_page>{url}</link_home_page>.
              </p>`
    },
    url: {
        id: 'components.ErrorBoundary.url',
        defaultMessage: `https://voicearchive.com`
    },
    email: {
      id: 'components.ErrorBoundary.email',
      defaultMessage: 'mail@voicearchive.com'
    },
    phone_number: {
        id:'components.ErrorBoundary.phone_number',
        defaultMessage: "+45 7022 7042"
    }
})
